import { SettoreVO } from "./settoreVO";
import { UtenteVO } from "./utenteVO";
import { StrutturaVO } from "./strutturaVO";
import { StrutturaFascicoloVO } from "./struttura-fascicoloVO";

export class AutoreVO {
    utente: UtenteVO = new UtenteVO();
    struttura: StrutturaFascicoloVO = new StrutturaFascicoloVO();
}
